/* ============================================================
   ZENITH APPAREL — Header JS (mobile menu + search)
   ============================================================ */
(function() {
  const header = document.getElementById('SiteHeader');
  if (!header) return;

  /* ---- Mobile menu ---- */
  const menuToggle = header.querySelector('.header__menu-toggle');
  const mobileMenu = document.getElementById('MobileMenu');
  const menuClose = mobileMenu?.querySelector('.mobile-menu__close');
  const menuOverlay = mobileMenu?.querySelector('.mobile-menu__overlay');

  function openMenu() {
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (menuClose) {
      setTimeout(() => menuClose.focus(), 50);
    }
    if (window.trapFocus) window.trapFocus(mobileMenu.querySelector('.mobile-menu__panel'));
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    menuToggle.focus();
  }

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMenu(); });
  }

  /* ---- Mobile accordion ---- */
  mobileMenu?.querySelectorAll('.mobile-menu__accordion-trigger').forEach(btn => {
    btn.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      const sub = this.nextElementSibling;
      if (sub) sub.hidden = expanded;
    });
  });

  /* ---- Search toggle ---- */
  const searchToggle = header.querySelector('.header__search-toggle');
  const searchBar = document.getElementById('SearchBar');
  const searchClose = searchBar?.querySelector('.header__search-close');
  const searchInput = searchBar?.querySelector('.header__search-input');

  function openSearch() {
    searchBar.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'true');
    if (searchInput) setTimeout(() => searchInput.focus(), 50);
  }

  function closeSearch() {
    searchBar.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.focus();
  }

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !searchBar.hidden) closeSearch(); });
  }
})();
